import { sendEventToStatsig } from '@/utils/statsig'
import type { Events } from '@/utils/event-bus'

const EVENT_NAME_MAP: Record<keyof Events, string> = {
  add_save_item: 'add_save_item',
  remove_save_item: 'remove_save_item',
  print_page: 'print_page',
}

export const addSaveItemStatsig = (event: Events['add_save_item']) => {
  sendEventToStatsig(EVENT_NAME_MAP['add_save_item'], event)
}

export const removeSaveItemStatsig = (event: Events['remove_save_item']) => {
  sendEventToStatsig(EVENT_NAME_MAP['remove_save_item'], event)
}

export const printPageStatsig = (event: Events['print_page']) => {
  sendEventToStatsig(EVENT_NAME_MAP['print_page'], event)
}
